module.exports = __webpack_public_path__ + "static/img/visitor-invite.9f91c0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/visitor-invite.png
// module id = 0GL6
// module chunks = 9